import {GameView} from "../base/GameView";
import {GameDialog} from "../base/GameDialog";
import {ObjectUtils} from "../../utils/ObjectUtils";

export class GameDialogLayer extends GameView {
  public hideAllDialogsWithType(dialogType: string): void {
    let dialogsToHide: GameDialog[] | null = null;
    for (let i = 0; i < this.children?.length; i++) {
      let dialog: GameDialog = this.getChildAt(i) as GameDialog;
      if (ObjectUtils.getQualifiedClassName(dialog) == dialogType) {
        if (!dialogsToHide) {
          dialogsToHide = [];
        }
        dialogsToHide.push(dialog);
      }
    }
    while (dialogsToHide && dialogsToHide.length) {
      dialogsToHide.pop()?.hide();
    }
  }

  override onResize() {
    for (let i = this.children.length - 1; i >= 0; i--) {
      let child = this.getChildAt(i);
      if(child instanceof GameDialog) {
        let dialog = child as GameDialog;
        dialog.onResize();
      }
    }
  }
}
